export default __webpack_public_path__ + "static/media/carovny-les.17a7a7c7.svg";